/**
 * External dependencies
 */
import React from "react";
import ContentLoader, { IContentLoaderProps } from "react-content-loader";

export const FilterLoader = ({ speed = 2, ...rest }: IContentLoaderProps) => {
	return (
		<ContentLoader
			speed={speed}
			width={302}
			height={72}
			viewBox="0 0 302 72"
			backgroundColor="#f3f3f3"
			foregroundColor="#ecebeb"
			style={{ width: "100%" }}
			preserveAspectRatio="none"
			{...rest}
		>
			<rect x="0" y="3" rx="0" ry="0" width="80" height="14" />
			<rect x="0" y="71" rx="0" ry="0" width="302" height="1" />
			<rect x="0" y="26" rx="0" ry="0" width="302" height="1" />
			<rect x="0" y="26" rx="0" ry="0" width="1" height="46" />
			<rect x="301" y="26" rx="0" ry="0" width="1" height="46" />
		</ContentLoader>
	);
};

interface FiltersLoaderProps {
	numOfItems: number;
	itemProps?: IContentLoaderProps;
}

export const FiltersLoader = ({
	numOfItems = 2,
	itemProps,
}: FiltersLoaderProps) => {
	let items = [];

	for (let i = 0; i < numOfItems; i++) {
		items.push(<FilterLoader key={i} {...itemProps} />);
	}

	return <div className="em-block-story-feed__filters">{items}</div>;
};

export const CardLoader = ({ speed = 2, ...rest }: IContentLoaderProps) => {
	return (
		<ContentLoader
			speed={speed}
			width={400}
			height={430}
			viewBox="0 0 400 430"
			backgroundColor="#f3f3f3"
			foregroundColor="#ecebeb"
			style={{ width: "100%" }}
			preserveAspectRatio="none"
			{...rest}
		>
			<rect x="0" y="0" rx="0" ry="0" width="400" height="225" />
			<rect x="0" y="0" rx="0" ry="0" width="1" height="430" />
			<rect x="399" y="0" rx="0" ry="0" width="1" height="430" />
			<rect x="0" y="429" rx="0" ry="0" width="400" height="1" />
			<rect x="20" y="250" rx="0" ry="0" width="235" height="25" />
			<rect x="20" y="340" rx="0" ry="0" width="90" height="15" />
			<rect x="20" y="400" rx="0" ry="0" width="45" height="10" />
			<rect x="75" y="400" rx="0" ry="0" width="45" height="10" />
			<rect x="130" y="400" rx="0" ry="0" width="45" height="10" />
		</ContentLoader>
	);
};

interface ResultsLoaderProps {
	numOfItems: number;
	itemProps?: IContentLoaderProps;
}

export const ResultsLoader = ({
	numOfItems,
	itemProps,
}: ResultsLoaderProps) => {
	let items = [];

	for (let i = 0; i < numOfItems; i++) {
		items.push(<CardLoader key={i} {...itemProps} />);
	}

	return (
		<div className="em-block-story-feed__results">
			<div className="em-block-story-feed__posts">
				{items}
			</div>
		</div>
	);
};

export const Spinner = () => {
	return <div className="spinner" />;
};
